import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import { themes } from './vuetify-theme'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    dark: false,
    themes
  }
})
